import { getObjectKeysAsObject } from "@checkout/helpers";
import { ParentState } from "@checkout/types";
import { MultiTicketTypeEnum } from "@hopper-b2b/types";
import type { PartialParentContextWithAirPriceDrop } from "./types";

export const guards = {
  hasPriceDropIdAndEnabled: (
    ctx: PartialParentContextWithAirPriceDrop,
    _event: unknown
  ) => {
    return (
      !!ctx[ParentState.priceDrop]?.candidateId &&
      ctx.featureFlags?.enablePriceDrop
    );
  },
  isFlightNotHackerfare: (
    ctx: PartialParentContextWithAirPriceDrop,
    _event: unknown
  ) => {
    return (
      ctx.flightShop?.tripDetails?.fareDetails.findIndex(
        (fare) => fare.multiTicketType === MultiTicketTypeEnum.HackerFare
      ) < 0
    );
  },
};

export const GuardTypes = getObjectKeysAsObject(guards);
